<template>
  <md-card>
    <md-card-content>
      <div class="title-wrapper">
        <h3>Date Range Activation</h3>
        <md-button
          class="md-icon-button"
          @click="viewExpanded = !viewExpanded"
        >
          <md-icon>
            {{ viewExpanded ? 'expand_less' : 'expand_more' }}
          </md-icon>
        </md-button>
      </div>

      <div
        class="body"
        :class="viewExpanded && '-visible'"
      >
        <div class="date-row">
          <label>Start date: </label>
          <Datetime
            v-model="model.startDate"
            zone="UTC"
            value-zone="UTC"
          />
        </div>
        <div
          v-if="!validation.start_date.isBeforeEndDate"
          class="error-feedback"
        >
          Start date must be before the end one!
        </div>

        <div class="spacer" />

        <div class="date-row">
          <label>End date: </label>
          <Datetime
            v-model="model.endDate"
            zone="UTC"
            value-zone="UTC"
          />
        </div>
        <div
          v-if="!validation.end_date.ifAfterStartDate"
          class="error-feedback"
        >
          End date must be after the start one!
        </div>

        <div class="check-wrapper">
          <md-checkbox
            v-model="model.enableOnInterval"
            :disabled="!enabled"
          >
            Enable on date interval
          </md-checkbox>
          <span
            class="enabled-error"
            :class="!enabled && '-show-error'"
          >
            "Enabled" must be checked first
          </span>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import { Datetime } from "vue-datetime";

export default {
    name: "DateRangeForm",
    components: {
        Datetime
    },
    props: {
        initial_date_interval: { type: Object, required: true },
        enabled: Boolean,
        validation: { type: Object, required: true }
    },
    data() {
        return {
            model: {
                startDate: this.$props.initial_date_interval.start_date,
                endDate: this.$props.initial_date_interval.end_date,
                enableOnInterval: this.$props.initial_date_interval.enable_on_date_interval,
            },
            skipNextProps: false,
            viewExpanded: false,
        };
    },
    watch: {
        "model": {
            handler: "emitUpdate",
            deep: true
        },
        "initial_date_interval": "mapFromProps"
    },
    methods: {
        emitUpdate() {
            this.$emit("dateRangeUpdated", {
                start_date: this.model.startDate.replace(".000", ""),
                end_date: this.model.endDate.replace(".000", ""),
                enable_on_date_interval: this.model.enableOnInterval,
            });
            this.skipNextProps = true;
        },
        mapFromProps() {
            if (!this.skipNextProps) {
                this.model = {
                    startDate: this.$props.initial_date_interval.start_date,
                    endDate: this.$props.initial_date_interval.end_date,
                    enableOnInterval: this.$props.initial_date_interval.enable_on_date_interval,
                };
            } else {
                this.skipNextProps = false;
            }
        }
    }
};
</script>
<style scoped lang="scss">
    .title-wrapper {
        display: flex;

        h3 {
          display: block;
          margin: 10px 0;
        }

        button {
          margin-left: 10px;
        }
    }

    .date-row {
        display: flex;

        label {
            margin-right: 10px;
        }
    }

    .body {
        display: none;

        &.-visible {
            display: block;
        }
    }

    .enabled-error {
        color: red;
        display: none;
        vertical-align: super;

        &.-show-error {
            display: inline;
        }
    }

    .error-feedback {
        font-size: 12px;
        color: red;
        margin-right: 5px;
    }

    .spacer {
        margin-top: 10px;
    }
</style>
